module.exports = "./img/aefcc67c61b0170ce75ceefee1afc716.jpg";